// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".staff[data-v-9c41c4ca] {\n  align-self: flex-end;\n}\n.staff.message-box[data-v-9c41c4ca] {\n  --tw-bg-opacity: 1;\n  background-color: rgba(219, 234, 254, var(--tw-bg-opacity));\n}\n.customer.message-box[data-v-9c41c4ca] {\n  --tw-bg-opacity: 1;\n  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));\n}\n", ""]);
// Exports
module.exports = exports;
